import { render, staticRenderFns } from "./Lgx456907876376510464.vue?vue&type=template&id=fbd263b4&scoped=true&"
import script from "./Lgx456907876376510464.vue?vue&type=script&lang=js&"
export * from "./Lgx456907876376510464.vue?vue&type=script&lang=js&"
import style0 from "./Lgx456907876376510464.vue?vue&type=style&index=0&id=fbd263b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd263b4",
  null
  
)

export default component.exports